import React from 'react';
import PropTypes from 'prop-types';
import isNaN from 'lodash/isNaN';
import { TextInput } from '@els/els-react--text-input';

function GoToPage({ chunksCount, onClick }) {
  const [inputValue, setInputValue] = React.useState('');

  const validateInputValue = (valueAsInteger) => {
    if (isNaN(valueAsInteger)) {
      return false;
    }

    if (valueAsInteger > chunksCount) {
      return false;
    }

    return valueAsInteger !== 0;
  };

  const goToHandler = () => {
    const valueAsInteger = parseInt(inputValue, 10);

    if (!validateInputValue(valueAsInteger)) return;

    onClick(valueAsInteger);
    setInputValue('');
  };

  const onChange = (e) => {
    const { value } = e.target;
    const valueAsInteger = parseInt(value, 10);
    const newInputValue = isNaN(valueAsInteger) ? '' : valueAsInteger;
    setInputValue(newInputValue);
  };

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      goToHandler();
    }
  };

  return (
    <TextInput
      iconRight={{
        id: 'goToPage',
        sprite: 'ChevronRight',
        color: 'secondary',
        a11y: {
          name: 'Go to page',
        },
      }}
      label="Go to page"
      shouldHideLabel
      value={inputValue}
      className="new-author-checkboxes-dialog__go-to-page"
      onKeyPress={onKeyPress}
      iconRightCallback={goToHandler}
      onChange={onChange}
    />
  );
}

GoToPage.propTypes = {
  chunksCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default GoToPage;
